import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import RpdDewasaSvc from "@/services/RpdDewasaService";

@Module({
  store,
  dynamic: true,
  namespaced: true,
  name: "rpd-dewasa"
})
class RpdDewasaModule extends VuexModule {
  currentItem: any = null;
  masters: any = null;
  loading = false;

  @Mutation SET_CURRENT_ITEM(val: any) {
    this.currentItem = val;
  }

  @Mutation SET_MASTERS(val: any) {
    this.masters = val;
  }

  @Mutation SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Action async loadMasters() {
    if (this.masters) return;
    try {
      const dt = await RpdDewasaSvc.getMasters();
      const { data } = dt.data;
      this.SET_MASTERS(data || null);
    } catch {
      this.SET_MASTERS(null);
    }
  }

  @Action async getByRegister(reg: string | number) {
    this.SET_LOADING(true);
    try {
      const dt = await RpdDewasaSvc.getByRegister(reg);
      const { data } = dt.data;
      this.SET_CURRENT_ITEM(data || null);
    } catch {
      this.SET_CURRENT_ITEM(null);
    }
    this.SET_LOADING(false);
  }

  @Action reset() {
    this.SET_CURRENT_ITEM(null);
  }
}

export const storeRpdDewasa = getModule(RpdDewasaModule);
